import { Box, Container, Toolbar } from "@mui/material";
import { DashboardLayout } from "components/DashboardLayout";
import Footer from "components/Footer";
import Header from "components/Header";
import { Outlet } from "react-router-dom";
import { useAuthStore } from "store/authStore";

const BlogLayout = () => {
  const { getUserAuthStatus } = useAuthStore();
  const isUserAuthenticated = getUserAuthStatus();

  if (isUserAuthenticated) {
    return <DashboardLayout />;
  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        height: "100vh",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      <Header />
      <Toolbar />
      <Box component="main" sx={{ minHeight: "calc(100dvh - 475px)", marginBottom: "48px" }}>
        <Container
          maxWidth={false}
          sx={{
            maxWidth: "1240px",
            margin: "0 auto",
            paddingTop: "24px",
          }}
        >
          <Outlet />
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default BlogLayout;
